import React from 'react';
import { Typography, Box } from '@material-ui/core';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import { getRiskScoreColor, getIvtRateColor } from '../styles/ivt';
import { MetricBox } from './utils';

const tooltips = {
  risk_score: 'Overall traffic quality score (0-100%) based on a weighted average of IVT tier classifications. Higher scores indicate more suspicious or invalid traffic patterns.',
  ivt_rate: 'Percentage of sampled traffic classified as Invalid Traffic (Tier 2+), including bot activity, spoofed domains, and other fraudulent signals.',
  mfa_rate: 'Percentage of traffic flagged as Made-for-Advertising, indicating low-quality sites designed primarily to generate ad revenue rather than serve genuine content.',
  spo_rate: 'Percentage of traffic with Supply Path Optimization issues, such as unauthorized resellers, missing ads.txt entries, or suspicious supply chain signals.',
};

export default function IvtMetricBoxes({ scanHistory }) {
  const latest = scanHistory.length > 0 ? scanHistory[0] : null;
  if (!latest) return null;

  const renderTrend = (field) => {
    if (scanHistory.length < 2) return null;
    const current = scanHistory[0][field];
    const previous = scanHistory[1][field];
    const diff = current - previous;
    if (Math.abs(diff) < 0.1) return null;
    const isImproving = diff < 0;
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', fontSize: '10px', color: 'rgba(255,255,255,0.8)', marginLeft: '4px' }}>
        {isImproving ? <TrendingDownIcon style={{ fontSize: '12px' }} /> : <TrendingUpIcon style={{ fontSize: '12px' }} />}
        {Math.abs(diff).toFixed(1)}%
      </span>
    );
  };

  return (
    <Box style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
      <MetricBox label="Risk Score" tooltip={tooltips.risk_score} color={getRiskScoreColor(latest.risk_score)}>
        <Typography style={{ color: '#fff', fontWeight: 'bold', fontSize: '14px', lineHeight: 1.2 }}>
          {latest.risk_score}%
          {renderTrend('risk_score')}
        </Typography>
      </MetricBox>
      <MetricBox label="IVT Rate" tooltip={tooltips.ivt_rate} color={getIvtRateColor(latest.ivt_rate)}>
        <Typography style={{ color: '#fff', fontWeight: 'bold', fontSize: '14px', lineHeight: 1.2 }}>
          {latest.ivt_rate}%
          {renderTrend('ivt_rate')}
        </Typography>
      </MetricBox>
      <MetricBox label="MFA Rate" tooltip={tooltips.mfa_rate} color={getIvtRateColor(latest.mfa_rate)}>
        <Typography style={{ color: '#fff', fontWeight: 'bold', fontSize: '14px', lineHeight: 1.2 }}>
          {latest.mfa_rate}%
          {renderTrend('mfa_rate')}
        </Typography>
      </MetricBox>
      <MetricBox label="SPO Rate" tooltip={tooltips.spo_rate} color={getIvtRateColor(latest.spo_rate)}>
        <Typography style={{ color: '#fff', fontWeight: 'bold', fontSize: '14px', lineHeight: 1.2 }}>
          {latest.spo_rate}%
          {renderTrend('spo_rate')}
        </Typography>
      </MetricBox>
    </Box>
  );
}
